var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGapIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#3B65E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1428 37.7053C10.524 37.0865 10.2146 36.7771 10.0987 36.4203C9.99673 36.1065 9.99673 35.7685 10.0987 35.4547C10.2146 35.0979 10.524 34.7885 11.1428 34.1697L25.576 19.7365C26.1948 19.1177 26.5042 18.8084 26.8609 18.6924C27.1747 18.5905 27.5128 18.5905 27.8266 18.6924C28.1834 18.8084 28.4927 19.1177 29.1115 19.7365L30.2635 20.8885C30.8823 21.5073 31.1917 21.8166 31.3076 22.1734C31.4095 22.4872 31.4095 22.8253 31.3076 23.1391C31.1917 23.4959 30.8823 23.8052 30.2635 24.424L15.8303 38.8572C15.2115 39.476 14.9021 39.7854 14.5453 39.9013C14.2315 40.0033 13.8935 40.0033 13.5797 39.9013C13.2229 39.7854 12.9135 39.476 12.2947 38.8572L11.1428 37.7053Z",
    fill: "#AFC1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 28.125L21.875 23.4375M29.7037 11.7188V9.375M35.8589 14.1573L37.5162 12.5M35.8589 26.5625L37.5162 28.2198M23.4537 14.1573L21.7964 12.5M38.2974 20.3125H40.6412M15.8303 38.8572L30.2635 24.424C30.8823 23.8052 31.1917 23.4959 31.3076 23.1391C31.4095 22.8253 31.4095 22.4872 31.3076 22.1734C31.1917 21.8166 30.8823 21.5073 30.2635 20.8885L29.1115 19.7365C28.4927 19.1177 28.1834 18.8084 27.8266 18.6924C27.5128 18.5905 27.1747 18.5905 26.8609 18.6924C26.5042 18.8084 26.1948 19.1177 25.576 19.7365L11.1428 34.1697C10.524 34.7885 10.2146 35.0979 10.0987 35.4547C9.99673 35.7685 9.99673 36.1065 10.0987 36.4203C10.2146 36.7771 10.524 37.0865 11.1428 37.7053L12.2947 38.8572C12.9135 39.476 13.2229 39.7854 13.5797 39.9013C13.8935 40.0033 14.2315 40.0033 14.5453 39.9013C14.9021 39.7854 15.2115 39.476 15.8303 38.8572Z",
    stroke: "#AFC1F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8884 20.6245L30.116 19.87C29.5514 19.3054 28.6566 18.4144 28.2332 18.1746C28.2251 18.1701 28.2453 18.1815 28.2352 18.1761C28.2176 18.1666 28.2258 18.1709 28.208 18.162C28.1977 18.1569 28.1375 18.1286 28.017 18.0721L28.017 18.0721C27.9648 18.0476 27.9149 18.0254 27.8674 18.0054C27.5873 17.8878 27.4473 17.829 27.2874 17.8162C27.1194 17.8029 27.0285 17.815 26.8699 17.872C26.7189 17.9262 26.4247 18.156 25.8362 18.6156C25.6178 18.7862 25.3466 19.0278 25 19.3745L21.875 22.4995L27.5 28.1245L30.625 24.9995C31.875 23.7495 31.8166 23.6294 31.9325 23.2726C32.0345 22.9588 31.9769 22.1883 31.875 21.8745C31.759 21.5177 31.5072 21.2432 30.8884 20.6245Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 9.375L29.6875 12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6238 20.3125L37.5 20.3982",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGapIconColour);
export default __webpack_public_path__ + "static/media/CloseGapIconColour.f245c42ff6857eb9702704aa75963b1f.svg";
export { ForwardRef as ReactComponent };